import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";

export default defineComponent ({
    name: 'NavBar',
    inheritAttrs: false, 
    setup() {
        const portal = usePortalStore();
        return {
            portal
        }
    }
})